export default __webpack_public_path__ + "static/media/ico-postgress-score-high.6f4c45c0.svg";